import { LOCAL_STORAGE_USED_BANKS } from 'common/localStorage/keys'

export const getUsedBanks = (): string[] => {
  const item = localStorage.getItem(LOCAL_STORAGE_USED_BANKS)

  return item ? JSON.parse(item) : []
}

export const addUsedBank = (bankName: string) => {
  const items = getUsedBanks()
  const banks = [bankName, ...items].slice(0, 5)

  localStorage.setItem(LOCAL_STORAGE_USED_BANKS, JSON.stringify(banks))

  return banks
}
